// ========================================
// DÉSACTIVATION DE LA LOGIQUE GRID_LIST AUTOMATIQUE
// ========================================

(function() {
  'use strict';
  
  // Désactiver Shopify.queryParams.grid_list
  if (typeof Shopify !== 'undefined' && Shopify.queryParams) {
    // Supprimer grid_list des paramètres existants
    if (Shopify.queryParams.grid_list) {
      delete Shopify.queryParams.grid_list;
    }
    
    // Intercepter les modifications futures
    const originalSetProperty = Object.defineProperty;
    Object.defineProperty = function(obj, prop, descriptor) {
      if (prop === 'grid_list') {
        return obj; // Ignorer les tentatives de définition de grid_list
      }
      return originalSetProperty.call(this, obj, prop, descriptor);
    };
  }
  
  // Désactiver la logique d'ajout automatique de grid_list aux liens
  function disableGridListOnLinks() {
    // Observer les modifications du DOM pour empêcher l'ajout de grid_list
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'href') {
          const link = mutation.target;
          const href = link.getAttribute('href');
          
          // Nettoyer les URLs qui contiennent grid_list
          if (href && href.includes('grid_list=')) {
            const cleanHref = href.replace(/[?&]grid_list=[^&]*/g, '');
            // Supprimer le ? initial si il n'y a plus de paramètres
            const finalHref = cleanHref.replace(/\?$/, '');
            link.setAttribute('href', finalHref);
          }
        }
      });
    });
    
    // Observer tous les liens existants et futurs
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['href']
    });
  }
  
  // Désactiver la redirection automatique
  function disableGridListRedirect() {
    // Intercepter les changements de location
    const originalReplace = window.location.replace;
    const originalAssign = window.location.assign;
    
    window.location.replace = function(url) {
      if (url && url.includes('grid_list=')) {
        const cleanUrl = url.replace(/[?&]grid_list=[^&]*/g, '');
        const finalUrl = cleanUrl.replace(/\?$/, '');
        return originalReplace.call(this, finalUrl);
      }
      return originalReplace.call(this, url);
    };
    
    window.location.assign = function(url) {
      if (url && url.includes('grid_list=')) {
        const cleanUrl = url.replace(/[?&]grid_list=[^&]*/g, '');
        const finalUrl = cleanUrl.replace(/\?$/, '');
        return originalAssign.call(this, finalUrl);
      }
      return originalAssign.call(this, url);
    };
  }
  
  // Nettoyer les URLs existantes au chargement
  function cleanExistingUrls() {
    const links = document.querySelectorAll('a[href*="grid_list"]');
    links.forEach(function(link) {
      const href = link.getAttribute('href');
      if (href) {
        const cleanHref = href.replace(/[?&]grid_list=[^&]*/g, '');
        const finalHref = cleanHref.replace(/\?$/, '');
        link.setAttribute('href', finalHref);
      }
    });
  }
  
  // Nettoyer l'URL actuelle si elle contient grid_list
  function cleanCurrentUrl() {
    if (window.location.href.includes('grid_list=')) {
      const cleanUrl = window.location.href.replace(/[?&]grid_list=[^&]*/g, '');
      const finalUrl = cleanUrl.replace(/\?$/, '');
      if (finalUrl !== window.location.href) {
        window.history.replaceState({}, document.title, finalUrl);
      }
    }
  }
  
  // Initialiser toutes les protections
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      disableGridListOnLinks();
      disableGridListRedirect();
      cleanExistingUrls();
      cleanCurrentUrl();
    });
  } else {
    disableGridListOnLinks();
    disableGridListRedirect();
    cleanExistingUrls();
    cleanCurrentUrl();
  }
  
  // Protection supplémentaire contre les scripts qui s'exécutent plus tard
  window.addEventListener('load', function() {
    cleanExistingUrls();
    cleanCurrentUrl();
  });
  
})(); 